import {
  type NineSegment,
  type NineSegmentIndicator as NineSegmentIndicatorBase,
  nineSegmentIndicators as nineSegmentIndicatorsBase,
  nineSegments,
} from '~/utils'

export type NineSegmentIndicator = Exclude<NineSegmentIndicatorBase, 'aNpi'>
export const nineSegmentIndicators = nineSegmentIndicatorsBase.filter(
  (indicator): indicator is NineSegmentIndicator => indicator !== 'aNpi',
)

export const nineSegmentIndicatorHelpMap: Record<NineSegmentIndicator, string> =
  {
    npi: '7+5+3+1',
    nNpi: '7+5',
    uNpi: '(3+1)/(4+3+2+1)',
  }

export type NineSegmentColumnKey =
  | NineSegment
  | NineSegmentIndicator
  | 'brandName'
  | 'brandNumber'
  | 'indicatorPad'

export const nineSegmentSortColumnKeys = [
  ...nineSegments,
  ...nineSegmentIndicators,
] as const satisfies readonly NineSegmentColumnKey[]
export type NineSegmentSortColumnKey =
  (typeof nineSegmentSortColumnKeys)[number]

export const nineSegmentDisplayColumnKeys = [
  ...nineSegments,
  ...nineSegmentIndicators,
] as const satisfies readonly NineSegmentColumnKey[]
export type NineSegmentDisplayColumnKey =
  (typeof nineSegmentDisplayColumnKeys)[number]
